import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contactSelect"]

  updateContacts(event) {
    const customerId = event.target.value

    if (!customerId) {
      this.contactSelectTarget.innerHTML = "" // Leeren, wenn nichts ausgewählt
      return
    }

    fetch(`/customers/${customerId}/contacts`, {
      headers: { Accept: "application/json" }
    })
      .then(response => response.json())
      .then(data => {
        this.contactSelectTarget.innerHTML = ""

        data.forEach(contact => {
          const option = document.createElement("option")
          option.value = contact.id
          option.textContent = contact.name
          this.contactSelectTarget.appendChild(option)
        })
      })
  }
}
